import {appSetLoading} from "store/actions/appAction";
import {setPayrollData} from "store/actions/payrollAction";
import axios from "../axios/axios";
import {errorDispatcher} from "helpers";
import shortid from "shortid";
import {apiSetAlert} from "./appApi";
import getCurrency from "helpers/currencyHelper";

export const apiGetPayroll = (token) => (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
        .get(`/accountings/salaries`, {
            headers: {Authorization: `Bearer ${token}`},
        })
        .then((response) => {
            dispatch(setPayrollData(response.data));
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};
export const apiSetPayroll = (props) => (dispatch, getState) => {
    const {payroll, token, callBack} = props;
    if (!payroll) return;
    dispatch(appSetLoading());
    const id = payroll.id;
    const req = id ? axios.put : axios.post;
    const data = payroll.data;
    req(`/accountings/salary${id ? "/" + id : ""}`, data, {headers: {Authorization: `Bearer ${token}`}})
        .then((response) => {
            dispatch(appSetLoading(false));
            dispatch(apiSetAlert(response.data.message, "success"));
            callBack && callBack();
        })
        .catch((error) => errorDispatcher(error, dispatch));
};

function normalizePayroll(data) {
    return data.map((item) => ({
        account: item.Account_Type,
        accountTypeId: item.AccountTypeId,
        type: getType(item.AccountTypeId),
        id: item.detail_id,
        ind: shortid.generate(),
        detailId: item.detail_id,
        price: item.amount || 0,
        currencyPrice: item.currency_amount,
        creditor: item.isCreditor ? item.amount : 0,
        debtor: item.isCreditor ? 0 : item.amount,
        title: item.detail || item.accountType,
        unit: item.product?.unit || "عدد",
        barcode: item.product?.barcode || 0,
        count: item.product?.count || 1,
        warehouse: item.product?.warehouse,
        currency: getCurrency().defCur.en_title,
        totalPrice: 0,
        number: 0,
        // date: formatDate(moment.now()),
        // delegationDate: formatDate(Date.now()),
    }));
}

export const otherAssetsTypeIds = [
    35, 36, 37, 40, 90, 91, 92, 94, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108,
];
export const otherDebtsTypeIds = [45, 111, 112, 113, 114, 115, 116, 117, 118, 119];
export const typeIds = {
    fund: 87,
    cashier: 88,
    bank: 89,
    product: 34,
    debtor: 93,
    receivableDoc: 95,
    onGoingDoc: 96,
    creditor: 109,
    payableDoc: 110,
    capital: 49,
    LegalReserve: 51,
    accumulatedProfitOrLoss: 54,
};

export function getType(id) {
    if (otherAssetsTypeIds.includes(id)) return "otherAsset";
    if (otherDebtsTypeIds.includes(id)) return "otherDebt";
    return Object.keys(typeIds).find((key) => typeIds[key] === id);
}
